import * as Actions from '../../actions/app/product_locations.actions'

const initialState = {
  assigned_locations: []
}

const productLocationsReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_PRODUCT_LOCATIONS: {
      return {
        ...state,
        assigned_locations: action.payload
      }
    }
    case Actions.TOGGLE_PRODUCT_LOCATION: {
      // Toggle logic: if exists remove, if not add
      const { locationId } = action.payload
      const exists = state.assigned_locations.includes(locationId)

      let newLocations
      if (exists) {
        newLocations = state.assigned_locations.filter(id => id !== locationId)
      } else {
        newLocations = [...state.assigned_locations, locationId]
      }

      return {
        ...state,
        assigned_locations: newLocations
      }
    }
    default: {
      return state
    }
  }
}

export default productLocationsReducer
